<template>
	<div class="adminAddAdmin">
		<b-row>
			<b-col class="d-flex align-items-center">
				<h6 class="mb-0">{{ $t('Admins') }} </h6>
			</b-col>
			
			<b-col class="text-right">
				<b-button
					@click="$bvModal.show('modal-admin-add-admin')"
					class="btn-search"
				>
					{{ $t('Add admin') }}
				</b-button>
			</b-col>
		</b-row>
		<div class="wrap-list-user">
			<b-table
				hover
				:fields="fields"
				:items="userData"
				thead-class="hidden_header"
			>
				<template v-slot:cell(avatar)="data">
					<b-avatar
						:size="44"
						class="bg-transparent"
						v-bind:class="{
							active:
								data.item.status == 1 &&
								data.item.is_deleted == 0 &&
								data.item.is_suspended == 0,
							'not-active':
								data.item.status == 1 &&
								data.item.is_deleted == 0 &&
								data.item.is_suspended == 1,
							delete:
								data.item.status == 1 &&
								data.item.is_deleted == 1 &&
								data.item.is_suspended == 0
						}"
						:src="
							data.item && data.item.profile_image
								? data.item.profile_image
								: '/images/avatar.png'
						"
					></b-avatar>
				</template>
				<template v-slot:cell(name)="data">
					<div class="title">
						<router-link
							id="sellerDetail"
							:event="data.item ? 'click' : ''"
							class="sellar-div"
							:class="data.item ? null : 'no-pointer'"
							:to="$i18nRoute({ name: 'seller-detail' }, data.item.id)"
							style="color: var(--projectPrimaryColor) !important;"
						>
							{{ data.item.name }}
						</router-link>
					</div>
					<a class="email" :href="'mailto:' + data.item.email">{{
						data.item.email
					}}</a>
				</template>
				<template v-slot:cell(memberSince)="data">
					<div class="title">
						{{ $t('manageUser.memberSince') }}
					</div>
					<div class="text">
						{{ formatDate(data.item.created_at) }}
					</div>
				</template>
				<template v-slot:cell(tooltip)="data">
					<span
						@click="deleteUser(data.item)"
						v-if="data.item.is_deleted == 0 && currentUser.id !== data.item.id"
					>
						<TrashIcon />
					</span>
				</template>
			</b-table>
			<infinite-loading @infinite="infiniteHandler" ref="infiniteLoading">
				<span slot="no-results"
					><b-alert show variant="light" v-if="!userData.length">{{
						$t('adminDashboard.list.dataEmpty')
					}}</b-alert></span
				>
				<span slot="no-more"></span>
			</infinite-loading>
		</div>
		<!-- ADD ADMIN MODAL -->
		<b-modal
			id="modal-admin-add-admin"
			centered
			no-close-on-backdrop
			hide-footer
			hide-header
			@hide="handleCloseModal"
		>
			<div class="content-admin-profile">
				<div class="wrap-content">
					<div class="content-body">
						<h6>{{ $t('Add admin by email') }}</h6>
						<b-row class="mb-3 px-4">
							<b-col cols="auto" class="d-flex align-items-center">
								<IconMail />
							</b-col>
							<b-col>
								<b-form-input
									v-model="adminMail"
									class="input-search"
									:placeholder="$t('Enter user mail')"
								></b-form-input>
							</b-col>
						</b-row>

						<b-form-group
							v-if="adminMailList.length > 0"
							:label="$t('Choose the admin email')"
							v-slot="{ ariaDescribedby }"
						>
							<b-form-radio
								v-for="user in adminMailList"
								:key="user.id"
								v-model="selectedUserId"
								:value="user.id"
								:aria-describedby="ariaDescribedby"
								class="mb-2"
							>
								<b-row>
									<b-col cols="auto">
										<b-avatar
											:size="30"
											class="bg-transparent"
											:src="
												user.profile_image
													? user.profile_image
													: '/images/avatar.png'
											"
										></b-avatar>
									</b-col>
									<b-col>
										{{ user.email }}
									</b-col>
									<b-col>
										{{ user.display_name }}
									</b-col>
								</b-row>
							</b-form-radio>
						</b-form-group>

						<div class="button-div">
							<b-button
								@click="$bvModal.hide('modal-admin-add-admin')"
								class="btn-submit-info reject-button"
								>{{ $t('cancel') }}
							</b-button>
							<b-button
								@click="
									selectedUserId ? handleAddAdmin() : handleSearchAdminMail()
								"
								type="submit"
								class="btn-submit-search"
							>
								<b-spinner
									v-if="addAdminLoading"
									small
									variant="primary"
									label="Spinning"
								></b-spinner>
								{{ addAdminBtnLoader }}
							</b-button>
						</div>
					</div>
				</div>
			</div>
		</b-modal>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import InfiniteLoading from 'vue-infinite-loading';
import moment from 'moment';

import TrashIcon from '@/components/icons/IconTrash';
import IconMail from '@/components/icons/IconMail';


export default {
	components: {
		InfiniteLoading,
		TrashIcon,
		IconMail,
	},
	data() {
		return {
			fields: [
				'avatar',
				'name',
				'memberSince',
				{ key: 'tooltip', tdClass: 'td-tooltip' }
			],
			selectedUserId: null,
			adminMail: null,
			adminMailList: [],
			addAdminLoading: false,
			searchParams: {
				take: 10,
				page: 1,
				search: '',
				sort_by: 'StartDateMember',
				onlyAdmin: true,
				dateFrom:null,
				dateTo:null
			},
			currentUser: localStorage.getItem('user_profile')
				? JSON.parse(localStorage.getItem('user_profile'))
				: {}
		};
	},
	watch: {
		// removed selected to search again
		adminMail(val) {
			this.selectedUserId = null;
		}
	},
	computed: {
		...mapGetters('UserManagerController', ['userData']),

		addAdminBtnLoader() {
			if (this.addAdminLoading) {
				return '';
			} else if (this.selectedUserId) {
				return this.$t('Add admin');
			} else {
				return this.$t('manageUser.search');
			}
		}
	},
	mounted() {
		let date = new Date();
		this.searchParams.dateFrom = '2017-01-01T08:03:36.115Z';
		this.searchParams.dateTo = new Date();
		this.fetchUser();
	},
	methods: {
		...mapActions('UserManagerController', [
			'GET_DATA_USER_MANAGER',
			'GET_USER_BY_EMAIL',
			'SET_USER_TO_ADMIN'
		]),

		fetchUser() {
			let prms = { ...this.searchParams };
			prms.page = 1;
			this.GET_DATA_USER_MANAGER(prms);
			this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
		},
		formatDate(date) {
			var formatTimezone = moment(date).toDate();
			return moment(formatTimezone)
				.locale('th')
				.format('DD MMM YYYY');
		},
		handleCloseModal() {
			this.selectedUserId = null;
			this.adminMailList = [];
			this.adminMail = null;
		},
		handleSearchAdminMail() {
			this.addAdminLoading = true;
			this.GET_USER_BY_EMAIL({ email: this.adminMail }).then(res => {
				this.addAdminLoading = false;
				if (res.data.data.length <= 0) {
					this.$bvToast.toast(this.$t('No users found'), {
						title: `Error!`,
						variant: 'danger',
						solid: true
					});
				}
				this.adminMailList = res.data.data;
			});
		},
		handleAddAdmin() {
			this.addAdminLoading = true;
			this.SET_USER_TO_ADMIN({ userId: this.selectedUserId, setAdmin: true })
				.then(res => {
					this.addAdminLoading = false;
					this.$bvModal.hide('modal-admin-add-admin');
					if (res.data.success) {
						this.fetchUser();
						this.$bvToast.toast(this.$t('Admin added successfully'), {
							title: `Success!`,
							variant: 'success',
							solid: true
						});
					} else if (res.data.status === 500) {
						this.$bvToast.toast(this.$t('User not found'), {
							title: `Error!`,
							variant: 'danger',
							solid: true
						});
					}
				})
				.catch(err => {
					this.$bvModal.hide('modal-admin-add-admin');
					this.$bvToast.toast(
						this.$t('There are some errors Please try again later'),
						{
							title: `Error!`,
							variant: 'danger',
							solid: true
						}
					);
				});
		},
		deleteUser(item) {
			if (item.admin_type_id == 1) {
				this.$swal({
					title: this.$t('Do you want to remove admin privilege'),
					text: item.name,
					customClass: {
						container: 'swal-del-item'
					},
					showCancelButton: true,
					cancelButtonColor: '#DC3849',
					confirmButtonColor: 'var(--projectPrimaryColor)',
					confirmButtonText: this.$t('cancel'),
					cancelButtonText: this.$t('delete')
				}).then(result => {
					if (result.dismiss == 'cancel') {
						this.SET_USER_TO_ADMIN({ userId: item.id, setAdmin: false })
							.then(res => {
								if (res.data.success) {
									this.fetchUser();
									this.$bvToast.toast(
										this.$t('Admin privilege removed successfully'),
										{
											title: `Success!`,
											variant: 'success',
											solid: true
										}
									);
								}
							})
							.catch(err => {
								this.$bvToast.toast(
									this.$t('There are some errors Please try again later'),
									{
										title: `Error!`,
										variant: 'danger',
										solid: true
									}
								);
							});
					}
				});
			}
		},
		infiniteHandler($state) {
			let prms = { ...this.searchParams };
			prms.page += 1;
			this.searchParams = prms;
			this.GET_DATA_USER_MANAGER(prms).then(async response => {
				if (response.data.data.length > 0) {
					await $state.loaded();
				} else {
					await $state.complete();
				}
			});
		}
	}
};
</script>

<style lang="scss">
@import 'adminAddAdmin.scss';
</style>
